export default __webpack_public_path__ + "static/media/logout.cd4c4507.svg";